import { render, staticRenderFns } from "./AditionalFormDialog.vue?vue&type=template&id=488b0b79&scoped=true"
import script from "./AditionalFormDialog.vue?vue&type=script&lang=js"
export * from "./AditionalFormDialog.vue?vue&type=script&lang=js"
import style0 from "./AditionalFormDialog.vue?vue&type=style&index=0&id=488b0b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b0b79",
  null
  
)

export default component.exports